export default {
  improvement_plans_detail: {
    create_form: {
      cautions_title: '@:settings.cautions_title',
      cautions_content: '・改进计划记载的内容将显示在 {toCompanyName} 中。\n・仅在{toCompanyName}中显示附件名，附件内容不会被共享。',
    },
    chat: {
      card_title: '信息',
      input_area_description: '您可以向{toCompanyName}发送有关改进计划的信息。',
      send_confirm: {
        modal_title: '信息发送确认',
        confirm_text: '您确定要发送此信息吗？',
        confirm_text_near_by_check_box: '信息已确认。',
        send_button_label: '@:upload_common.send',
      },
      send_complete: {
        // toast_text:
      },
      delete_confirm: {
        modal_title: '信息删除确认',
        confirm_text: '您确定要删除此信息吗？',
        delete_button_label: '@:settings.button.do_delete',
      },
      log: {
        title: '发送/接收历史记录',
        send_status: {
          success: '已发送',
          failure: '发送失败',
        },
      },
    },
  },
}
